import { useState, useCallback, useEffect } from 'react';

export function useToast() {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({ title: '', description: '' });

  // Automatically close toast after duration
  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        setOpen(false);
      }, 5000); // 5 seconds

      return () => clearTimeout(timer);
    }
  }, [open]);

  const toast = useCallback(({ title, description }) => {
    setData({ title, description });
    setOpen(true);
  }, []);

  return {
    open,
    setOpen,
    data,
    toast,
  };
} 